import { useLocation } from "@/lib/router";
import { sectionById } from "@/data/sections";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Home } from "@/pages/Home";
import { ArticlePage } from "@/pages/ArticlePage";
import { NotFound, SearchPage, SectionPage, VideoPage } from "@/pages/Listing";

// URL shapes:
//   /                        front page
//   /section/:id             section front
//   /:section/:slug          article
//   /video, /search?q=...
function Route() {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);

  if (parts.length === 0) return <Home />;
  if (parts[0] === "video" && parts.length === 1) return <VideoPage />;
  if (parts[0] === "search" && parts.length === 1) return <SearchPage />;
  if (parts[0] === "section" && parts.length === 2) return <SectionPage id={parts[1]!} />;
  if (parts.length === 2 && sectionById(parts[0]!)) return <ArticlePage key={parts[1]} slug={parts[1]!} />;
  return <NotFound />;
}

export function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Route />
      <Footer />
    </div>
  );
}
